import { render, staticRenderFns } from "./CommitmentIcon.vue?vue&type=template&id=e3e753f0"
import script from "./CommitmentIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CommitmentIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports